import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Store } from '@ngxs/store';
import { ActivatedRoute } from '@angular/router';
import { FeatureFlag, Module, NewPermission } from '@core/enums';
import { AccountState } from '@state/account/state';
import { UserState } from '@state/user/state';

@Component({
  selector: 'tasks-tab',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LegacyTasksTabComponent {
  @ViewChild('drawer') drawer: MatDrawer;

  constructor(private readonly activatedRoute: ActivatedRoute, private readonly store: Store) {}

  get module(): string | undefined {
    return this.activatedRoute.snapshot.data?.module;
  }

  canViewGlobaTasks(): boolean {
    if (!this.store.selectSnapshot(AccountState.isFeatureEnabled(FeatureFlag.NEW_PERMISSIONS))) {
      return true;
    }

    return this.store.selectSnapshot(
      UserState.hasPermission(
        [Module.DEALS, Module.PROPERTIES, Module.CUSTOM_OBJECTS].includes(this.module as Module)
          ? NewPermission.AGGREGATED_TASK_LISTS_VIEW
          : NewPermission.GLOBAL_TASK_LISTS_VIEW,
      ),
    );
  }
}
